/**
 * Search API
 *
 * Network-only functions for destination search/auto-suggest.
 * NO Redux imports allowed in this file.
 *
 * Uses common API utilities which automatically add:
 * - Headers: X-Gommt-Mmt-Auth, X-Gommt-Uuid, X-Device-Id
 */
import * as v from 'valibot';
import { type DestinationSuggestion, AutoSuggestApiResponseSchema } from '@contracts';
import { ONBOARDING_ENDPOINTS } from '@/api/endpoints';
import { fetchApi, validateApiResponse, buildUrl, buildHeaders } from './apiUtils';

/**
 * Fetch auto-suggest results for destination search
 * Returns popular destinations when query is empty
 *
 * Uses common API utilities with automatic:
 * - Headers: X-Gommt-Mmt-Auth, X-Gommt-Uuid, X-Device-Id
 */
export async function fetchAutoSuggest(query: string): Promise<DestinationSuggestion[]> {
  const url = buildUrl(ONBOARDING_ENDPOINTS.AUTO_SUGGEST, { query });

  const { data, response } = await fetchApi({
    url,
    method: 'GET',
    headers: buildHeaders(),
  });

  const parsedResponse = v.parse(AutoSuggestApiResponseSchema, data);
  validateApiResponse(parsedResponse, response);

  return parsedResponse.suggestions ?? [];
}
